import type {
  ProduceOutputPrepDetails,
  ShowPreparedItemApiResponse,
} from "../types/produceOutputFlow.types";

export const mapShowPreparedItemToPrepDetails = (
  data: ShowPreparedItemApiResponse,
): ProduceOutputPrepDetails => ({
  preparedItemId: data.id,
  setupQty: data.setup_qty,
  outputUom: data.output_uom.short_name,
  ingredients: data.ingredients.map((ingredient) => ({
    id: ingredient.id,
    sku: ingredient.sku,
    name: ingredient.name,
    setupQty: ingredient.setup_qty,
    availableStock: Number(ingredient.available_stock) || 0,
    currentAcc: ingredient.average_current_cost,
    baseUom: ingredient.base_uom.short_name,
  })),
});
